import { useState, useCallback } from 'react';

import { UploadType } from '../components/core/UploadArea/types';

export default function useUploadArgs() {
  const [args, setArgs] = useState<{
    inputFiles: File[];
    uploadType?: string;
  }>({ inputFiles: [] });
  const onUpload = useCallback((files: File[], uploadType: UploadType) => {
    setArgs({ inputFiles: files, uploadType });
  }, []);

  return [onUpload, args.inputFiles, args.uploadType] as const;
}
